<div class="mobile-banner" [@fadeAnimation]="imgSrc">
  <img [src]="imgSrc" alt="" />
</div>
